import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../../Base.constants';
import { SearchDocumentsDto } from '../../../../../services/dtos/securities/searchDocuments.dto';
import { getArticleId } from '../../CompanyDocumentsTab.logic';
import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';
import styles from './DisabledReportLinkRenderer.module.scss';

const cx = classNames.bind(styles);

const DisabledReportLinkRenderer = ({
  data,
  row: { isDisabled, isHovered },
}: GroupedTableRowRendererProps<SearchDocumentsDto>): ReactElement | null => {
  if (isHovered && isDisabled) {
    return <Link to={ROUTES.article(getArticleId(data))} className={cx('body')} tabIndex={-1} />;
  }
  return null;
};

export default DisabledReportLinkRenderer;
